module.exports = __webpack_public_path__ + "static/media/beyond-gut-feeling-sml.96704258.png";